import { render, staticRenderFns } from "./editMainCategoryProduct.vue?vue&type=template&id=a5e80194"
import script from "./editMainCategoryProduct.vue?vue&type=script&lang=js"
export * from "./editMainCategoryProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports